/**
 * Generate a clean, readable task title from a user message.
 *
 * Strips filler prefixes, agent mentions, takes the first sentence,
 * truncates at a word boundary (~60 chars), and capitalizes.
 */

const AGENT_MENTION_RE = /^@\S+\s+/;

const FILLER_PREFIXES = [
  "can you please",
  "could you please",
  "would you please",
  "i need you to",
  "i want you to",
  "i would like you to",
  "i'd like you to",
  "please help me",
  "help me",
  "can you",
  "could you",
  "would you",
  "please",
  "go ahead and",
  "i need to",
  "i want to",
];

const SENTENCE_END_RE = /[.!?\n]/;
const MAX_LENGTH = 60;
const MIN_LENGTH = 3;

export function generateTaskTitle(message: string): string {
  let text = message.trim();

  // Strip agent mention (e.g. "@researcher find papers...")
  text = text.replace(AGENT_MENTION_RE, "");

  // Strip filler prefixes (longest match first — already ordered by length)
  const lower = text.toLowerCase();
  for (const prefix of FILLER_PREFIXES) {
    if (lower.startsWith(prefix)) {
      text = text.slice(prefix.length).trimStart();
      break;
    }
  }

  // Take first sentence
  const sentenceEnd = text.search(SENTENCE_END_RE);
  if (sentenceEnd > 0) {
    text = text.slice(0, sentenceEnd);
  }

  // Truncate at word boundary
  text = text.trim();
  if (text.length > MAX_LENGTH) {
    const truncated = text.slice(0, MAX_LENGTH);
    const lastSpace = truncated.lastIndexOf(" ");
    text = lastSpace > 20 ? truncated.slice(0, lastSpace) : truncated;
  }

  // Capitalize first letter
  if (text.length > 0) {
    text = text.charAt(0).toUpperCase() + text.slice(1);
  }

  return text.length >= MIN_LENGTH ? text : "New Task";
}
